/**
 * Lightweight client-side breadcrumb logger for auth flows (login, password
 * reset, token refresh). Lets us pinpoint *which* stage failed when a user
 * reports an "authentication error", from the browser console or an error
 * reporter. Never log passwords or full tokens — stage + status + a short
 * message only.
 */
export function logAuthStage(
    stage: string,
    detail?: Record<string, unknown>,
): void {
    // eslint-disable-next-line no-console
    console.info(`[auth] ${stage}`, detail ?? {});
}
